import { Grid, Typography } from '@mui/material'
import { SectionBreak, ElementBreak, Heading } from '../shared'
import { ReactNode } from 'react'

interface FormSectionProps {
  title: string
  children: ReactNode
  spacing?: number
}

/**
 * Reusable Form Section Wrapper
 * Provides consistent styling and layout for form sections
 */
export const FormSection = ({ title, children, spacing = 2 }: FormSectionProps) => {
  return (
    <SectionBreak>
      <Grid container sx={{ marginBottom: '20px' }}>
        <Heading>{title}</Heading>
      </Grid>
      <Grid container spacing={spacing}>
        {children}
      </Grid>
    </SectionBreak>
  )
}

export default FormSection
